export const OPTIONS_USER_DEFINED_PROPERTY = 'digitaix-forms-options';
export const ON_EVENT_USER_DEFINED_PROPERTY = 'digitaix-forms-on-event';
export const SET_INPUT_USER_DEFINED_PROPERTY = 'digitaix-forms-input';
